module.exports = __webpack_public_path__ + "img/sndle-avatar-default.02cd993c.png";